import { createContext as e } from "react";
import { LanguageResolver as o } from "./languageResolver.js";
const n = e(new o("fr"));
export {
  n as LanguageResolverContext
};
//# sourceMappingURL=language.js.map
